import * as React from "react"

export default function ProfileIconOutline(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.667 14.666a5.333 5.333 0 0110.666 0H12a4 4 0 10-8 0H2.667zm5.333-6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-1.333A2.666 2.666 0 108 2a2.666 2.666 0 100 5.333z"
        fill={props.fill}
      />
    </svg>
  )
}
